import $store from '../store'
import { AuthService } from '@/services/auth.service'
// const LANDING_URL = process.env.VUE_APP_LANDING_URL
/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
export async function initCurrentUserStateMiddleware (to, from, next) {
  const currentUserId = $store.state.user.currentUser.ID
  // if (to.name === 'index' || to.path === '/') {
  //   window.location = LANDING_URL + '?tracking=' + (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15))
  //   return
  // }
  if ((to.path === '/auth/login' || to.path === '/auth/otp' || to.path === '/password/forget') && (AuthService.hasBearer() && currentUserId)) {
    return next({ name: 'loanSummary' })
  }

  if (AuthService.hasBearer() && !currentUserId) {
    try {
      await $store.dispatch('user/getCurrent')
      next()
    } catch (e) {
      console.log(e)
    }
  } else {
    next()
  }

  /* if (to.name !== 'index' && to.path !== '/' && to.path !== '/auth/login' && to.path !== '/auth/otp' && to.path !== '/password/forget' && !currentUserId) {
    return $store.dispatch('user/getCurrent')
      .then(() => next())
      .catch(error => console.log(error))
  } */
  next()
}

/**
 * Check access permission to auth routes
 */
export async function checkAccessMiddleware (to, from, next) {
  const isAuthRoute = to.matched.some(item => item.meta.isAuth)
  const currentUserId = $store.state.user.currentUser.ID
  if (isAuthRoute) {
    if (!AuthService.hasBearer()) {
      return next({ name: 'login' })
    } else {
      if (!currentUserId) {
        try {
          await $store.dispatch('user/getCurrent').then(() => {
          }).catch((error) => {
            if (error.status === 401) {
              return next({ name: 'login' })
            }
          })
          next()
        } catch (e) {
          console.log(e)
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
}

export function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)

  if (pageTitle) window.document.title = pageTitle.meta.title
  next()
}
